import { render } from "./trainCourseLookVideo.vue?vue&type=template&id=12a1e9d1&scoped=true"
import script from "./trainCourseLookVideo.vue?vue&type=script&lang=js"
export * from "./trainCourseLookVideo.vue?vue&type=script&lang=js"

import "./trainCourseLookVideo.vue?vue&type=style&index=0&id=12a1e9d1&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a1e9d1"]])

export default __exports__